import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const AntTabs = withStyles({
    root: {
        borderBottom: 'none',
    },
    indicator: {
        backgroundColor: '#1E88E5',
    },
})(Tabs);

const AntTab = withStyles(theme => ({
    root: {
        textTransform: 'none',
        minWidth: 72,
        fontWeight: theme.typography.fontWeightRegular,
        marginRight: theme.spacing(4),
        '&:hover': {
            color: '#1E88E5',
            opacity: 1,
        },
        '&$selected': {
            color: '#1E88E5',
            fontWeight: theme.typography.fontWeightMedium,
        },
        '&:focus': {
            color: '#1E88E5',
        },
    },
    selected: {},
}))(props => <Tab disableRipple {...props} />);


export { AntTabs, AntTab };